module.exports = __webpack_public_path__ + "static/banner-90bb908d311d25263e389ce4d0da456c.png";